import { Icon } from "@chakra-ui/react"

export const PadlockIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" width="23" height="31" viewBox="0 0 23 31">
    <g id="Group_1148" data-name="Group 1148" transform="translate(0 0)">
      <g id="Group_1147" data-name="Group 1147">
        <path id="Path_555" data-name="Path 555" d="M1589.574,823.306h-1.141V820.1a8.593,8.593,0,1,0-17.187-.008V823.3h-1.133a2.037,2.037,0,0,0-2.034,2.034v15.184a2.036,2.036,0,0,0,2.034,2.033h19.466a2.036,2.036,0,0,0,2.035-2.033V825.335a2.044,2.044,0,0,0-2.04-2.029Zm-15.741-3.213a6.007,6.007,0,0,1,12.015,0v3.2h-12.015v-3.2Zm15.184,19.874h-18.353V825.892h18.359v14.075Z" transform="translate(-1568.079 -811.501)" fill="#06bcc1"/>
        <path id="Path_556" data-name="Path 556" d="M1574.971,828.443a1.29,1.29,0,0,0,1.292-1.292v-3.334a1.293,1.293,0,0,0-2.586,0v3.334A1.3,1.3,0,0,0,1574.971,828.443Z" transform="translate(-1563.209 -801.911)" fill="#06bcc1"/>
      </g>
    </g>
  </Icon>
);
